const initialState = {
    isLoading: true
};

/* eslint-disable-next-line default-param-last */
const resourcesReducers = (state = initialState) => state;

export default resourcesReducers;